function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Typography, Box, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { Button } from "../Button";
import { Notification } from "../Notification";
import { _UploadWrapper, _TypographyWrapper, _IconWrapper, _InputWrapper, HelperTextStyled } from "./styles";
import UploadIcon from "../../icons/UploadCloudOutline";
import CloseIcon from "../../icons/CloseOutlineIcon";
import { GRAY, RED } from "../../constants/colors/hex";
function preventDefaults(e) {
  e.preventDefault();
  e.stopPropagation();
}
function isInvalidFile(file) {
  return !file.link && !file.name;
}
export function Upload(props) {
  var dropZoneRef = useRef(null);
  var fileInputRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    highlight = _useState2[0],
    setHighlight = _useState2[1];
  var files = props.files || [];
  useEffect(function () {
    if (dropZoneRef.current !== null) {
      addEventListeners();
    }
    return function () {
      removeEventListeners();
    };
  }, []);
  var addEventListeners = function addEventListeners() {
    dropZoneRef.current.addEventListener('drop', handleDrop);
    dropZoneRef.current.addEventListener('drop', preventDefaults);
    dropZoneRef.current.addEventListener('dragover', highlightTrue);
    dropZoneRef.current.addEventListener('dragover', preventDefaults);
    dropZoneRef.current.addEventListener('dragenter', highlightTrue);
    dropZoneRef.current.addEventListener('dragenter', preventDefaults);
    dropZoneRef.current.addEventListener('dragleave', highlightFalse);
    dropZoneRef.current.addEventListener('dragleave', preventDefaults);
  };
  var removeEventListeners = function removeEventListeners() {
    dropZoneRef.current.removeEventListener('drop', handleDrop);
    dropZoneRef.current.removeEventListener('drop', preventDefaults);
    dropZoneRef.current.removeEventListener('dragover', highlightTrue);
    dropZoneRef.current.removeEventListener('dragover', preventDefaults);
    dropZoneRef.current.removeEventListener('dragenter', highlightTrue);
    dropZoneRef.current.removeEventListener('dragenter', preventDefaults);
    dropZoneRef.current.addEventListener('dragleave', highlightFalse);
    dropZoneRef.current.addEventListener('dragleave', preventDefaults);
  };
  var highlightTrue = function highlightTrue() {
    setHighlight(true);
  };
  var highlightFalse = function highlightFalse() {
    setHighlight(false);
  };
  var handleDrop = function handleDrop(e) {
    addNewFiles(e.dataTransfer.files);
  };
  var addNewFiles = function addNewFiles(fileList) {
    var files = convertFileListToArray(fileList);
    props.onAddFiles(files);
  };
  var triggerFileSelector = function triggerFileSelector() {
    // Clear the file value before clicking it to avoid a browser behavior that ignores the same file being uploaded
    // See: https://github.com/valor-software/ng2-file-upload/issues/871#issuecomment-328294164
    // See: https://stackoverflow.com/a/24608023
    fileInputRef.current.value = null;
    fileInputRef.current.click();
  };
  var anyFilesInErrorState = files.some(isInvalidFile);
  var _useState3 = useState(anyFilesInErrorState),
    _useState4 = _slicedToArray(_useState3, 2),
    showFileError = _useState4[0],
    setShowFileError = _useState4[1];
  var handleCloseFileErrorNotification = useCallback(function () {
    return setShowFileError(false);
  }, [setShowFileError]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_UploadWrapper, {
    inline: props.inline,
    fullWidth: props.fullWidth,
    error: props.error,
    forwardedRef: dropZoneRef,
    highlight: highlight
  }, files.length === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_IconWrapper, {
    inline: props.inline
  }, /*#__PURE__*/React.createElement(UploadIcon, null)), /*#__PURE__*/React.createElement(_TypographyWrapper, {
    inline: props.inline
  }, /*#__PURE__*/React.createElement(Typography, {
    align: props.textAlign,
    style: {
      whiteSpace: 'pre-wrap'
    }
  }, props.dropZoneText || 'Drag and drop, or')), /*#__PURE__*/React.createElement(Button, {
    onClick: triggerFileSelector,
    variant: "outlined",
    color: "primary",
    disableFocusRipple: false,
    disableRipple: false
  }, "Browse Files")), files.length > 0 && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    width: "100%"
  }, anyFilesInErrorState && showFileError && /*#__PURE__*/React.createElement(Notification, {
    color: "negative",
    onClose: handleCloseFileErrorNotification
  }, "You have an invalid file. Please replace it with a new document."), files.map(function (file, idx) {
    var fileType = getFileType(file);
    var linkAvailable = !!file.link;
    var isFileInErrorState = isInvalidFile(file);
    return /*#__PURE__*/React.createElement(Box, {
      key: idx,
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      mt: idx === 0 && !showFileError ? 0 : 2
    }, /*#__PURE__*/React.createElement(Box, {
      display: "flex"
    }, /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "center",
      mr: 2
    }, /*#__PURE__*/React.createElement(FileIcon, {
      isError: isFileInErrorState
    })), /*#__PURE__*/React.createElement("div", null, isFileInErrorState ? /*#__PURE__*/React.createElement(HelperTextStyled, {
      error: true
    }, "Invalid file") : /*#__PURE__*/React.createElement(Typography, null, linkAvailable ? /*#__PURE__*/React.createElement("a", {
      href: file.link,
      target: "_blank",
      rel: "noopener noreferrer"
    }, file.name || file.link) : file.name), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, file.size !== null && prettifyFileSize(file.size), fileType ? " \xB7 ".concat(fileType) : ''))), /*#__PURE__*/React.createElement(IconButton, {
      disableRipple: false,
      disableFocusRipple: false,
      style: {
        outline: 'none'
      },
      "aria-label": "Remove ".concat(file.name || 'File'),
      onClick: function onClick() {
        if (props.onDeleteFile) {
          props.onDeleteFile(file);
        }
      }
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      "aria-hidden": true
    })));
  }), files.length > 0 && props.multiple && /*#__PURE__*/React.createElement(Box, {
    borderTop: "1px solid ".concat(GRAY[18]),
    width: "100%",
    mt: 3,
    pt: 2.5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    disableRipple: false,
    disableFocusRipple: false,
    startIcon: /*#__PURE__*/React.createElement(AddIcon, null),
    variant: "outlined",
    color: "secondary",
    onClick: triggerFileSelector
  }, "Add More Files"))), /*#__PURE__*/React.createElement(_InputWrapper, null, /*#__PURE__*/React.createElement("input", {
    ref: fileInputRef,
    type: "file",
    multiple: props.multiple,
    accept: props.accept,
    onChange: function onChange(e) {
      var fileList = e.target.files;
      if (!fileList || fileList.length === 0) {
        return;
      }
      addNewFiles(fileList);
    }
  }))), props.helperText && /*#__PURE__*/React.createElement(HelperTextStyled, {
    error: props.error
  }, props.helperText));
}
function FileIcon(_ref) {
  var isError = _ref.isError;
  return /*#__PURE__*/React.createElement("svg", {
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z",
    fill: isError ? RED[20] : '#D0E4FF'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24h8v2h-8v-2zm0-4h8v2h-8v-2zm6-10h-8c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H26c1.1 0 2-.9 2-2V16l-6-6zm4 18H14V12h7v5h5v11z",
    fill: isError ? RED[5] : '#003384'
  }));
}
function convertFileListToArray(fileList) {
  if (!fileList) {
    return [];
  }
  var filesArr = [];
  for (var i = 0; i < fileList.length; i++) {
    filesArr.push(fileList.item(i));
  }
  return filesArr;
}

/**
 * Format bytes as human-readable text.
 *
 * @see https://stackoverflow.com/a/14919494
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
function prettifyFileSize(bytes) {
  var si = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var dp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var thresh = si ? 1000 : 1024;
  if (Math.abs(bytes) < thresh) {
    return "".concat(bytes, " B");
  }
  var units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  var u = -1;
  var r = Math.pow(10, dp);
  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  return "".concat(bytes.toFixed(dp), " ").concat(units[u]);
}
function getFileType(fileAttributes) {
  var _fileAttributes$name;
  if (fileAttributes.contentType === 'image/jpeg') {
    return 'JPG';
  }
  if (fileAttributes.contentType === 'image/png') {
    return 'PNG';
  }
  if (((_fileAttributes$name = fileAttributes.name) === null || _fileAttributes$name === void 0 ? void 0 : _fileAttributes$name.indexOf('.')) > -1) {
    var fileNameParts = fileAttributes.name.split('.');
    return fileNameParts[fileNameParts.length - 1].toUpperCase();
  }
  return null;
}
Upload.defaultProps = {
  inline: true,
  accept: '*',
  multiple: false,
  textAlign: 'center'
};